import { PassportProduct } from '@app/core/interfaces';
import { PolicyProductIdEnum } from 'outshared-lib';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
export const passportProductsData: PassportProduct[] = [
    {
        productId: PolicyProductIdEnum.Car,
        productDescription: 'autoverzekering',
        productText: 'Auto',
        productIcon: 'car',
        purchased: 0,
        productRank: 10,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Motorcycle,
        productDescription: 'motorverzekering',
        productText: 'Motor',
        productIcon: 'motorcycle',
        purchased: 0,
        productRank: 30,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Moped,
        productDescription: 'brommerverzekering',
        productText: 'Brommer',
        productIcon: 'moped',
        purchased: 0,
        productRank: 20,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Home,
        productDescription: 'woonverzekering',
        productText: 'Wonen',
        productIcon: 'home-insurance',
        purchased: 0,
        productRank: 50,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Travel,
        productDescription: 'reisverzekering',
        productText: 'Reis',
        productIcon: 'travel',
        purchased: 0,
        productRank: 60,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Liability,
        productDescription: 'aansprakelijkheidsverzekering',
        productText: 'Aansprakelijkheid',
        productIcon: 'liability',
        purchased: 0,
        productRank: 5,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Pet,
        productDescription: 'dierenverzekering',
        productText: 'Dier',
        productIcon: 'pet',
        purchased: 0,
        productRank: 70,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.LegalAssistance,
        productDescription: 'rechtsbijstandverzekering',
        productText: 'Rechtsbijstand',
        productIcon: 'legal',
        purchased: 0,
        productRank: 80,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Accidents,
        productDescription: 'ongevallenverzekering',
        productText: 'Ongevallen',
        productIcon: 'accident',
        purchased: 0,
        productRank: 90,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Caravan,
        productDescription: 'caravanverzekering',
        productText: 'Caravan',
        productIcon: 'caravan',
        purchased: 0,
        productRank: 40,
        productSequenceNumber: 0,
    },
    {
        productId: PolicyProductIdEnum.Bicycle,
        productDescription: 'fietsverzekering',
        productText: 'Fiets',
        productIcon: 'bicycle',
        purchased: 0,
        productRank: 35,
        productSequenceNumber: 0,
    },
];
